export function documentUrl(path){return '/api/documents/download?path='+encodeURIComponent(path)}
